import {Alert, Button, FormControl} from "react-bootstrap";
import { to } from "../../Utils";

import AdContentTable from "./components/AdContentTable";
import AdContentForm from "./components/AdContentForm";
import Container from "../../components/Container";
import moment from "moment";
import React from "react";
import Graph from "./components/Graph";
import API from "../../services/API";

class AdContentArbitrage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            values: {
                network: [],
                campaign: [],
                site: [],
                country: []
            },
            report: {
                params: []
            },
            cron: {
                running: true,
                date: "",
                message: ""
            },
            graph: {},
            error: ""
        }

        this.loadGraph = this.loadGraph.bind(this);
        this.loadFilters = this.loadFilters.bind(this);
        this.loadReport = this.loadReport.bind(this);
        this.loadCronStatus = this.loadCronStatus.bind(this);
        this.startCron = this.startCron.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.error) {
            setTimeout(() => this.setState({ error: "" }), 2000)
        }
    }

    componentDidMount() {
        (async () => {
            this.loadGraph().catch((error) => console.error(error));

            this.loadCronStatus().then(() => {
                setInterval(() => {
                    this.loadCronStatus().catch((error) => console.error(error))
                }, 5000)
            }).catch((error) => console.error(error))
        })()
    }

    async startCron() {
        const { running, date } = this.state.cron;
        if (!date) return alert('Select date first');
        if (running) return alert('Cron already running')

        const [ error, response = {} ] = await to(API.AdContent.Arbitrage.cron.start(date));
        if (error) console.error(error);

        if (response.error) alert(response.error);

        return this.loadCronStatus()
    }

    async loadCronStatus() {
        const [ error, response ] = await to(API.AdContent.Arbitrage.cron.status());
        if (error) console.error(error);

        this.setState({ cron: response })
    }

    async loadGraph(filters = {}) {
        if (!filters.dateFrom) filters.dateFrom = moment().utc().subtract(8, 'day').format('YYYY-MM-DD');
        if (!filters.dateTo) filters.dateTo = moment().utc().subtract(1, 'day').format('YYYY-MM-DD');

        const [ error, response ] = await to(API.AdContent.Arbitrage.get({ ...filters, groupBy: [ 'date' ] }));
        if (error) console.error(error);

        this.setState({ graph: { ...response, timestamp: Date.now() } })
    }

    async loadFilters(filters, columns) {
        if (!filters.dateFrom) return this.setState({ error: `Select "Date From" first` })

        this.setState({ isLoading: true });

        filters = Object.entries({ ...filters, groupBy: undefined }).reduce((object, [ key, value ]) => {
            if (value && value.length) object[key] = value;

            return object;
        }, {})

        let values = await Promise.all(columns.map((column) => API.AdContent.Arbitrage.values(filters, column)))
            values = columns.reduce((object, column, index) => ({ ...object, [ column ]: values[index] }), {})

        this.setState({ isLoading: false, values: { ...this.state.values, ...values } })
    }

    async loadReport(filters) {
        if (!filters.dateFrom) return this.setState({ error: `Select "Date From" filter` })
        if (!filters.groupBy.length) return this.setState({ error: `Select "GroupBy" filter` })

        this.setState({ isLoading: true })

        const report = filters.groupBy.includes('keyword') || filters.groupBy.includes('adtitle') ? await API.AdContent.Arbitrage.keywords(filters) : await API.AdContent.Arbitrage.get(filters);

        await this.loadGraph(filters);

        this.setState({ isLoading: false, report })
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <div style={{ display: "flex", alignItems: 'center', width: '100%' }} className={'page-header'}>
                    <h1 style={{ margin: 0 }}>Ad Content Arbitrage</h1>

                    <div style={{ display: 'flex', position: 'absolute', right: '25px', height: '40px', alignItems: 'center' }}>
                        <span style={{ marginRight: '10px' }}>{this.state.cron.message}</span>

                        <FormControl
                            style={{ width: '200px', marginRight: '10px' }}
                            type="date"
                            name="date"
                            max={moment().subtract(1, 'day').format('YYYY-MM-DD')}
                            onChange={({ target: { value } }) => this.setState({ cron: { ...this.state.cron, date: value }})}
                            value={this.state.cron.date}
                        />

                        <Button onClick={this.startCron} bsStyle={this.state.cron.running ? "danger" : "primary"} disabled={this.state.cron.running}>{this.state.cron.running ? "Running" : "Start"}</Button>
                    </div>
                </div>

                {this.state.error && <Alert bsStyle={"danger"}>{this.state.error}</Alert>}

                <AdContentForm values={this.state.values} loadReport={this.loadReport} loadFilters={this.loadFilters}>
                    {Object.keys(this.state.graph) && <Graph graph={this.state.graph} />}
                </AdContentForm>

                <AdContentTable report={this.state.report} PARAMS_NAME={this.state.report.params.includes('keyword') ? { clicks: 'Conversions' } : {}}/>
            </Container>
        )
    }
}

export default AdContentArbitrage;


// WEBPACK FOOTER //
// ./src/scenes/AdContentArbitrage/index.js